import { useEffect } from "react";
import { Refine, Authenticated } from "@refinedev/core";
import { RefineThemes, ErrorComponent } from "@refinedev/antd";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import routerProvider, {
  CatchAllNavigate,
} from "@refinedev/react-router-v6";
import { ConfigProvider, App as AntApp } from "antd";
import "@refinedev/antd/dist/reset.css";
import ruRU from "antd/locale/ru_RU";

import { authProvider, bootstrapTokenFromHash } from "./authProvider";
import { dataProvider } from "./dataProvider";
import { AppLayout } from "./components/layout/AppLayout";
import { DashboardPage } from "./pages/dashboard/DashboardPage";
import { TransactionsPage } from "./pages/transactions/TransactionsPage";
import { LoginPage } from "./pages/LoginPage";

export const App: React.FC = () => {
  // На старте — забираем JWT из URL hash (после OIDC redirect)
  useEffect(() => {
    bootstrapTokenFromHash();
  }, []);

  return (
    <BrowserRouter>
      <ConfigProvider theme={RefineThemes.Blue} locale={ruRU}>
        <AntApp>
          <Refine
            authProvider={authProvider}
            dataProvider={dataProvider}
            routerProvider={routerProvider}
            resources={[
              {
                name: "dashboard",
                list: "/dashboard",
              },
              {
                name: "transactions",
                list: "/transactions",
              },
            ]}
            options={{
              syncWithLocation: true,
              warnWhenUnsavedChanges: true,
              title: { text: "BNLegal Finance", icon: <span /> },
            }}
          >
            <Routes>
              {/* Публичные */}
              <Route path="/login" element={<LoginPage />} />

              {/* Защищённые — обёрнуты в Authenticated */}
              <Route
                element={
                  <Authenticated
                    key="auth"
                    fallback={<CatchAllNavigate to="/login" />}
                  >
                    <AppLayout />
                  </Authenticated>
                }
              >
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/transactions" element={<TransactionsPage />} />

                {/* Catch-all для защищённых маршрутов */}
                <Route path="*" element={<ErrorComponent />} />
              </Route>
            </Routes>
          </Refine>
        </AntApp>
      </ConfigProvider>
    </BrowserRouter>
  );
};
